window.itgDisableAddButtonsRefreshTimer = null;
window.itgDisableAddButtonsObserver = null;
window.itgDisableAddButtonsObservedElement = null;

function itgUpdateDisableAddButtons() {
    var doc = $(document)

    var isStoreUnavailable = function (element) {
        var compactPickup = element && element.nextElementSibling
        if (!compactPickup || compactPickup.tagName !== 'PICKUP-AVAILABILITY-COMPACT') {
            return false
        }

        var changeStoreButton = compactPickup.querySelector('#change-store')
        var availabilityValue = changeStoreButton
            ? changeStoreButton.getAttribute('data-available')
            : null

        return availabilityValue === 'false'
    }

    doc
        .find('.product-item,.product-item__text,.product-text')
        .removeClass('disable-addbtn')

    var hasShippingCards = doc.find('.shipping-indicator-card').length > 0
    var hasPickupRows = doc.find('.itg-ship-pickup').length > 0

    if (!hasShippingCards && !hasPickupRows) {
        return
    }

    doc
        .find('.shipping-indicator-card')
        .find('.unavailable-delivery')
        .each(function () {
            var storeUnavailable = isStoreUnavailable(this)
            if (storeUnavailable) {
                $(this)
                    .parents('.product-item')
                    .addClass('disable-addbtn')
            } else {
                $(this)
                    .parents('.product-item')
                    .removeClass('disable-addbtn')
            }
        })

    doc
        .find('.itg-ship-pickup')
        .find('.unavailable-delivery')
        .each(function () {
            var storeUnavailable = isStoreUnavailable(this)
            if (storeUnavailable) {
                $(this).parents('.product-text').addClass('disable-addbtn')
            } else {
                $(this).parents('.product-text').removeClass('disable-addbtn')
            }
        })
}

window.itgScheduleDisableAddButtonsRefresh = function (delay = 120) {
    clearTimeout(window.itgDisableAddButtonsRefreshTimer)
    window.itgDisableAddButtonsRefreshTimer = setTimeout(function () {
        itgUpdateDisableAddButtons()
    }, delay)
}

window.itgInitDisableAddButtonsObserver = function () {
    if (!document.body) {
        return
    }

    var relevantSelector = '.shipping-indicator-card, .itg-ship-pickup, .unavailable-delivery, pickup-availability-compact, #change-store'
    var observeRoot =
        document.getElementById('AjaxCartForm') ||
        document.querySelector('.shipping-indicator') ||
        document.querySelector('[data-js-site-cart-sidebar]') ||
        document.getElementById('main')

    if (!observeRoot) {
        return
    }

    if (
        window.itgDisableAddButtonsObserver &&
        window.itgDisableAddButtonsObservedElement &&
        !document.body.contains(window.itgDisableAddButtonsObservedElement)
    ) {
        window.itgDisableAddButtonsObserver.disconnect()
        window.itgDisableAddButtonsObserver = null
        window.itgDisableAddButtonsObservedElement = null
    }

    if (
        window.itgDisableAddButtonsObserver &&
        window.itgDisableAddButtonsObservedElement === observeRoot
    ) {
        return
    }

    if (window.itgDisableAddButtonsObserver) {
        window.itgDisableAddButtonsObserver.disconnect()
        window.itgDisableAddButtonsObserver = null
    }

    var isRelevantNode = function (node) {
        return !!(
            node &&
            node.nodeType === 1 &&
            (node.matches(relevantSelector) || node.querySelector(relevantSelector))
        )
    }

    window.itgDisableAddButtonsObserver = new MutationObserver(function (mutations) {
        var shouldRefresh = false

        mutations.forEach(function (mutation) {
            if (shouldRefresh) return

            if (mutation.type === 'attributes' && mutation.target?.matches?.('#change-store, .unavailable-delivery, pickup-availability-compact')) {
                shouldRefresh = true
                return
            }

            mutation.addedNodes.forEach(function (node) {
                if (shouldRefresh) return
                if (isRelevantNode(node)) {
                    shouldRefresh = true
                }
            })

            mutation.removedNodes.forEach(function (node) {
                if (shouldRefresh) return
                if (isRelevantNode(node)) {
                    shouldRefresh = true
                }
            })
        })

        if (shouldRefresh) {
            window.itgScheduleDisableAddButtonsRefresh(120)
        }
    })

    window.itgDisableAddButtonsObserver.observe(observeRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-available']
    })
    window.itgDisableAddButtonsObservedElement = observeRoot
}

$(document).on('click', '#change-store', function () {
    $(document).find('#site-store-selector-handle').trigger('click')
    if (typeof window.itgScheduleDisableAddButtonsRefresh === 'function') {
        window.itgScheduleDisableAddButtonsRefresh(180)
    }
})

document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.itgInitDisableAddButtonsObserver === 'function') {
        window.itgInitDisableAddButtonsObserver()
    }
    if (typeof window.itgScheduleDisableAddButtonsRefresh === 'function') {
        window.itgScheduleDisableAddButtonsRefresh(120)
    }
})
